import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import {
  BB,
  BodyTextS,
  BodyTextSStrong,
  GRAY20,
  GRAY60,
  GRAY90,
  SubtitleM,
} from 'global-styles';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import styled, { css } from 'styled-components';
import format from 'date-fns/format';
import { useBlogContext } from 'context/BlogContext';
import { useRouter } from 'next/router';

interface Props {
  title: string;
  category: string;
  publishedDate?: string;
  thumbnail: string;
  postId: number;
  forPostUI?: boolean;
}

const PostCard = ({
  title,
  category,
  publishedDate,
  thumbnail,
  postId,
  forPostUI = false,
}: Props) => {
  const { dispatch } = useBlogContext();
  const { locale } = useRouter();

  const handleClickPostCard = () => {
    // list 에서의 scrollY 위치 기억하기
    const { scrollY } = window;
    dispatch({ type: 'change', newState: { prevScrollTop: scrollY } });
  };

  return (
    <PostCardContainer forPostUI={forPostUI} onClick={handleClickPostCard}>
      <Link href={`/blog/post/${postId}`}>
        <a className="pc-inner-container">
          <span className="tn-wrapper">
            <ImgBackgroundWrapper isNormalUse>
              <Image
                src={thumbnail}
                layout="fill"
                alt={title}
                className="target-img"
                objectFit="cover"
                quality={40}
              />
            </ImgBackgroundWrapper>
          </span>

          <div className="info-area">
            <BodyTextSStrong className="pc-cat">{category}</BodyTextSStrong>

            <SubtitleM className="pc-title">
              {title.replaceAll('&#8216;', '‘').replaceAll('&#8217;', '’')}
            </SubtitleM>

            {publishedDate && !forPostUI && (
              <BodyTextS className="pc-date">
                {locale === 'en'
                  ? format(new Date(publishedDate.slice(0, 10)), 'yyyy-MM-dd')
                  : format(
                      new Date(publishedDate.slice(0, 10)),
                      'yyyy년 MM월 dd일'
                    )}
              </BodyTextS>
            )}
          </div>
        </a>
      </Link>
    </PostCardContainer>
  );
};

export default PostCard;

const PostCardContainer = styled.li<{ forPostUI: boolean }>`
  background: #fff;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
  border-radius: 12px;

  .pc-inner-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 20px;
  }
  .info-area {
    width: 100%;
  }
  .tn-wrapper {
    width: 100%;
    display: inline-block;
    padding-top: 56.25%;
    position: relative;
    margin-bottom: 12px;
    border: 1px solid ${GRAY90};
    border-radius: 4px;
    overflow: hidden;
  }
  .tn-wrapper::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: 0.3s opacity ease-in;
  }
  .pc-cat {
    color: ${BB};
    text-transform: capitalize;
  }
  .pc-title {
    margin: 12px 0;
    width: 100%;
    overflow: hidden;
    display: block;
  }
  .pc-title {
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    color: ${GRAY20};
  }
  .pc-date {
    color: ${GRAY60};
  }

  & img {
    transition: 0.3s transform ease-in;
  }
  .pc-inner-container:hover {
    cursor: pointer;
    .pc-title > span {
      text-decoration: underline;
    }
    img {
      transform: scale(1.1);
    }
    .tn-wrapper::after {
      opacity: 1;
    }
  }
  @media screen and (min-width: 1240px) {
    .pc-title {
      font-size: 17px;
    }
  }
  @media screen and (max-width: 1239px) {
    .pc-inner-container {
      padding: 20px;
    }
  }
  @media screen and (max-width: 599px) {
    .pc-inner-container {
      padding: 16px;
    }
  }
  ${({ forPostUI }) =>
    forPostUI === true &&
    css`
      width: 180px;
      .pc-inner-container {
        padding: 12px;
      }
      .pc-title {
        font-size: 14px;
      }
    `};
`;
